const categories = [
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
];

export const calculateChartsData = (hexagons) => {
  const scope = {
    'AIR-CO': {},
    'AIR-HCHO': {},
    'AIR-NO2': {},
    'AIR-SO2': {},
    'LST-DIF': {},
    LST: {},
    NDVI: {},
  };
  hexagons.forEach((hexagon) => {
    Object.keys(scope).forEach((metric) => {
      Object.keys(hexagon.properties.metrics[metric]).forEach((year) => {
        let value = hexagon.properties.metrics[metric][year].value_max;
        if (metric === 'LST-DIF')
          value = hexagon.properties.metrics[metric][year];
        if (scope[metric][year]) {
          scope[metric][year] += value;
        } else {
          scope[metric][year] = value;
        }
      });
    });
  });
  Object.keys(scope).forEach((metric) => {
    Object.keys(scope[metric]).forEach((year) => {
      scope[metric][year] =
        Math.round((scope[metric][year] / hexagons.length) * 10) / 10;
    });
  });
  Object.keys(scope).forEach((metric) => {
    scope[metric] = categories.map((year) => scope[metric][year] || 0);
  });
  return scope;
};
